import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Langues } from 'src/api/models';
import { DevExtremeTranslationService } from 'src/core/services/devExtremeTranslation.service';
import { PanelLayoutService } from 'src/core/services/panel-layout.service';
import { ControlPanelService } from 'src/states/control-panel.service';

@Component({
  selector: 'app-langues-popup',
  templateUrl: './langues-popup.component.html',
  styleUrls: ['./langues-popup.component.css']
})
export class LanguesPopupComponent implements OnInit {
  @Input() public visible: boolean;
  @Output() onSave = new EventEmitter<Langues>();

  public selectedLangue = Langues.Francais;
  langues: any[];

  constructor(private translate: TranslateService,
    private controlPanelService: ControlPanelService,
    private panelLayoutService: PanelLayoutService,
    private devExtremeTranslationService: DevExtremeTranslationService) {
      // Instanciate Globalize for DevExtreme components
      this.devExtremeTranslationService.loadLanguage(this.translate.getBrowserLang());
      // TRANSLATIONS
      this.panelLayoutService.LoadTranslation().subscribe(() => {
        this.langues = this.panelLayoutService.GetLanguesSelection();
      });
    }

  ngOnInit() {
  }

  onShowing() {
    this.selectedLangue = Langues.Francais;
  }

  select() {
    this.visible = false;
    this.onSave.emit(this.selectedLangue);
  }

  cancelClicked() {
    this.visible = false;
    this.onSave.emit(null);
  }
}
